export const JIRA_PRODUCT_DISCOVERY_PRODUCT_ID = 'a6f908c8-709c-45f4-9e2d-eca25b93b94a';

export const JIRA_PRODUCT_IDS = {
  JWM: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
  JSM: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
  JSW: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
};

export const ATLAS_PRODUCT_ID = '7c917705-866d-4b6b-b266-0fc7633e8342';

export const LOOM_PRODUCT_ID = '7683a73e-423d-41a1-b43f-d497656f8b5d';

export const ROVO_PRODUCT_ID = '91ae3e3f-138e-43be-98cc-48df03d13c32';

export const BITBUCKET_PRODUCT_ID = 'ad1076cd-0b3f-4e57-8f46-3dcd70ee259f';

export const TEAMWORK_COLLECTION_PRODUCT_ID = '3503c251-c247-4b55-a6ed-d4c8c3257b8b';

export const STRATEGY_COLLECTION_PRODUCT_ID = '3e6f105a-4f6d-44d1-8716-7e9468544d93';

export const COLLECTION_PRODUCT_IDS = [TEAMWORK_COLLECTION_PRODUCT_ID, STRATEGY_COLLECTION_PRODUCT_ID];

export const CONFLUENCE_PRODUCT_ID = '6aab3f4e-cc71-474d-8d28-abef8b057808';

export const STATUSPAGE_PRODUCT_ID = '0b8ea1e2-52df-11ea-8d77-2e728ce88125';

export const COMPASS_PRODUCT_ID = '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2';

export const ATLASSIAN_ACCESS_PRODUCT_ID = 'ad8473d4-3a4d-4e36-827c-0a893439e9fa';

export const ELIGIBLE_PRODUCTS_FOR_ORDERING = [
  JIRA_PRODUCT_IDS.JWM,
  CONFLUENCE_PRODUCT_ID,
  ATLAS_PRODUCT_ID,
  JIRA_PRODUCT_DISCOVERY_PRODUCT_ID,
  JIRA_PRODUCT_IDS.JSW,
  JIRA_PRODUCT_IDS.JSM,
  COMPASS_PRODUCT_ID,
  ATLASSIAN_ACCESS_PRODUCT_ID,
  LOOM_PRODUCT_ID,
];

export const CATALOG_EXCLUDE_PRODUCTS = [ATLASSIAN_ACCESS_PRODUCT_ID];

export const APPS_SUPPORTABLE_PRODUCTS = [
  JIRA_PRODUCT_IDS.JWM,
  JIRA_PRODUCT_IDS.JSW,
  JIRA_PRODUCT_IDS.JSM,
  CONFLUENCE_PRODUCT_ID,
];
